import Inputmask from 'inputmask';

const $document = $(document);
const $ask = $('.ask');

function initForm() {
	let $form = $ask.find('.ask__form');
	let $checkbox = $form.find('.ask__checkbox-item');

	$form.on('submit', (e) => {
		let $currentForm = $(e.currentTarget);

		$currentForm.addClass('ajax-loading');

		$.ajax({
			type: 'POST',
			url: '/ajax/form.php',
			data: $currentForm.serializeArray(),
			dataType: 'json',
			success(data) {
				$currentForm
					.removeClass('ajax-loading')
					.get(0)
					.reset();

				if (data.success) {
					let $submitButton = $currentForm.find('.ask__button');
					let $message = $('.message-wrap');

					$document.trigger('main-form-succes');
					$submitButton.hide();

					$message.fadeIn(() => {
						setTimeout(() => {
							$message.hide();
							$submitButton.fadeIn();
						}, 4000);
					});
				}
			},
			error() {
				$currentForm.removeClass('ajax-loading');
			},
		});

		return false;
	});

	$checkbox.on('change', (e) => {
		let $submitButton = $(e.currentTarget).closest('.ask__form').find('.ask__button button');

		if (e.currentTarget.checked) {
			$submitButton
				.removeClass('is-disabled')
				.prop('disabled', false);
		} else {
			$submitButton
				.addClass('is-disabled')
				.prop('disabled', true);
		}
	});
}

if ($ask.length) {
	const $inputEmail = $ask.find('.ask__input--email input');

	let emailMask = new Inputmask({
		mask: '*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]',
		greedy: false,
		onBeforePaste(pastedValue) {
			pastedValue = pastedValue.toLowerCase();

			return pastedValue.replace('mailto:', '');
		},
		definitions: {
			'*': {
				validator: "[0-9A-Za-z!#$%&'*+/=?^_`{|}~\-]", // eslint-disable-line no-useless-escape
				casing: 'lower',
			},
		},
	});

	emailMask.mask($inputEmail.get(0));

	initForm();
}
